var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',_vm._g(_vm._b({ref:"form",attrs:{"autocomplete":"off","novalidate":""},on:{"submit":function($event){$event.preventDefault();}}},'form',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }